import React, { Fragment, useEffect, useState } from "react";
import { CustomDiv } from "../../../../modules/chat-bot/style";
import { Field, Form, Formik } from "formik";
import { CommonGrid2 } from "../../../../modules/common-components/StyledComponents";
import { Avatar, Typography } from "@mui/material";
import CommonTextField from "../../../../component/Input";
import { HandleSkeletion } from "../../../../utils/constants";
import PasswordIco from "../../../../assets/icons/PasswordIco";
import CommonButton from "../../../../component/Button";
import {
  TeamGetCall,
  UserManagementPut,
} from "../../../../redux/action/UserManagement";
import SnackBar from "../../../../component/SnackBar";
import DialogCandidateHub from "../../../../modules/jobs/jobs-candidate/components/DialogCandidateHub";
import StatusChangeIco from "../../../../assets/icons/StatusChangeIco";
import EditIcon from "@mui/icons-material/Edit";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { CustomizeSpan } from "../../../../modules/jobs/style";

export default function MyProfile() {
  const [profileData, setProfileData] = useState({
    username: "",
    email: "",
    title: "",
    password: "",
  });
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [loading, setLoading] = useState(false);
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const [passwordChange, setPasswordChange] = useState({
    open: false,
    disabled: false,
    saveLoading: false,
    data: "",
    value: "",
  });
  const [button, setButton] = useState({
    condition: true,
    disabled: false,
    saveLoading: false,
    cancelLoading: false,
  });
  const primaryViewData = [
    {
      title: "User Name",
      component: "input",
      titleName: "username",
      placeholder: "Enter User Name",
      placeholderFontSize: "15px",
      disabled: button.condition,
      required: true,
    },
    {
      title: "Email Address",
      component: "input",
      titleName: "email",
      placeholder: "Enter Email Address",
      placeholderFontSize: "15px",
      disabled: button.condition,
      required: true,
    },
    {
      title: "Designation",
      component: "input",
      titleName: "title",
      placeholder: "Enter Designation",
      placeholderFontSize: "15px",
      disabled: button.condition,
      required: true,
    },
    // {
    //   title: "Agency Name",
    //   component: "input",
    //   titleName: "",
    //   placeholder: "Enter Company Name",
    //   placeholderFontSize: "15px",
    //   disabled: true,
    // },
  ];

  const security = [
    {
      name: "Password",
      description: "Set an unique password to keep your account safe.",
    },
  ];
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    username: Yup.string().required("User Name is required"),
    title: Yup.string().required("Title is required"),
    email: Yup.string()
      .required("Email is required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email address"
      ),
  });

  const fetchCall = async () => {
    setLoading(true);
    try {
      let data = await TeamGetCall(true, localStorageData?.user_id);
      setProfileData((prev) => ({
        ...prev,
        ...data?.data,
        username: data?.data?.username || "",
        email: data?.data?.email || "",
        title: data?.data?.title || "",
      }));
      setLoading(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCall();
  }, []);

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handlePasswordChange = (setFieldValue) => {
    setPasswordChange((prev) => ({
      ...prev,
      open: true,
      data: setFieldValue,
    }));
  };

  const validatePassword = (password) => {
    if (password.length < 8) {
      return "Password must be at least 8 characters";
    }
    if (!/[A-Z]/.test(password)) {
      return "Password must contain at least one uppercase letter";
    }
    if (!/[a-z]/.test(password)) {
      return "Password must contain at least one lowercase letter";
    }
    if (!/[0-9]/.test(password)) {
      return "Password must contain at least one number";
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      return "Password must contain at least one special character";
    }
    return "";
  };

  const handleSaveClick = () => {
    const error = validatePassword(passwordChange.value);
    if (error) {
      return;
    } else {
      setPasswordChange((prev) => ({
        ...prev,
        disabled: true,
        saveLoading: true,
      }));
      setTimeout(() => {
        handlePasswordClose();
      }, 1000);
    }
  };

  const PasswordFooter = () => (
    <CommonButton
      value={"Save"}
      width={"100%"}
      variant="contained"
      color="white"
      background="#D92D20"
      padding={"10px"}
      marginTop={"1rem"}
      fontWeight={"700"}
      fontSize={"15px"}
      disabled={passwordChange.disabled}
      loading={passwordChange.saveLoading}
      onClick={() => handleSaveClick()}
    />
  );

  const handleContent = () => {
    return (
      <CommonGrid2 marginTop={"1rem"}>
        <CommonTextField
          placeholder={"Enter password"}
          padding="10px"
          error={validatePassword(passwordChange.value)}
          value={passwordChange.value}
          onChange={(e) => {
            setPasswordChange((prev) => ({
              ...prev,
              value: e.target.value,
            }));
            passwordChange.data("password", e.target.value);
          }}
          helperText={validatePassword(passwordChange.value)}
        />
      </CommonGrid2>
    );
  };

  const handlePasswordClose = () => {
    setPasswordChange((prev) => ({
      ...prev,
      open: false,
      disabled: false,
      saveLoading: false,
      data: "",
      value: "",
    }));
  };

  const handleEditDetails = () => {
    setButton((prev) => ({
      ...prev,
      condition: false,
    }));
  };

  const handleCancel = () => {
    setButton((prev) => ({
      ...prev,
      disabled: true,
      cancelLoading: true,
    }));
    setTimeout(() => {
      setButton((prev) => ({
        ...prev,
        disabled: false,
        cancelLoading: false,
        condition: true,
      }));
      fetchCall();
    }, 1000);
  };

  const handleSubmit = async (values) => {
    try {
      setButton((prev) => ({
        ...prev,
        disabled: true,
        saveLoading: true,
      }));
      let payload = {
        ...values,
      };
      const data = await UserManagementPut(localStorageData?.user_id, payload);
      const getData = JSON.parse(localStorage.getItem("credential"));
      let overallData = {
        ...getData,
        username: values.username,
      };
      window.localStorage.setItem("credential", JSON.stringify(overallData));
      fetchCall();
      setSnackbarState({
        open: true,
        severity: "success",
        message: data.message,
      });
      setButton((prev) => ({
        ...prev,
        condition: true,
        disabled: false,
        saveLoading: false,
      }));
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setButton((prev) => ({
        ...prev,
        disabled: false,
        saveLoading: false,
      }));
    }
  };

  return (
    <CustomDiv padding="1.5rem">
      <Formik
        enableReinitialize
        initialValues={profileData}
        validationSchema={validationSchema}
        onSubmit={async (values, actions) => {
          handleSubmit(values);
        }}
      >
        {({ values, errors, validateForm, touched, setFieldValue }) => {
          return (
            <Form
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
            >
              <CommonGrid2 container spacing={2} flexDirection={"column"}>
                <CommonGrid2>
                  <Typography variant="body5">Profile Details</Typography>

                  <CommonGrid2
                    size={12}
                    display={"flex"}
                    gap={"1rem"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    border={"1px solid #EAECF0"}
                    borderRadius={"10px"}
                    padding={"1rem"}
                    flexWrap={"wrap"}
                    marginTop={"1rem"}
                  >
                    <CommonGrid2
                      display={"flex"}
                      gap={"1rem"}
                      alignItems={"center"}
                    >
                      {loading ? (
                        <HandleSkeletion
                          width="50px"
                          height="50px"
                          // marginRight={"1rem"}
                          transform="scale(1)"
                          borderRadius="50px"
                        />
                      ) : (
                        <Avatar
                          alt="Olivia Rhye"
                          sx={{ width: 55, height: 55, fontWeight: "700" }}
                        >
                          {values.username.charAt(0)?.toUpperCase()}
                        </Avatar>
                      )}
                      <CommonGrid2 display={"flex"} flexDirection={"column"}>
                        {loading ? (
                          <HandleSkeletion width="80px" height="30px" />
                        ) : (
                          <Typography variant="body3">
                            {values.username}
                          </Typography>
                        )}
                        {loading ? (
                          <HandleSkeletion width="120px" height="40px" />
                        ) : (
                          <Typography
                            variant="body3"
                            color="#667085"
                            fontWeight={500}
                          >
                            {values.title}
                          </Typography>
                        )}
                      </CommonGrid2>
                    </CommonGrid2>
                    {loading ? (
                      <HandleSkeletion
                        height={50}
                        width={120}
                        transform={"scale(1)"}
                      />
                    ) : (
                      <CommonButton
                        value={"Change Picture"}
                        fontWeight={700}
                        fontSize={"16px"}
                        padding={"10px 16px"}
                        color="#6941C6"
                        backgroundColor="transparent"
                        boxShadow={"none"}
                        disabled
                        customStyle={{
                          "&:hover": {
                            boxShadow: "none",
                          },
                        }}
                      />
                    )}
                  </CommonGrid2>
                </CommonGrid2>

                <CommonGrid2
                  container
                  marginTop={"0.5rem"}
                  columnSpacing={3}
                  rowSpacing={loading ? 0 : 2}
                >
                  {primaryViewData?.map((item, index) => {
                    return (
                      <CommonGrid2
                        item
                        size={{
                          xs: 12,
                          md: 6,
                          sm: 6,
                        }}
                        key={item.title}
                        gap={"5px"}
                        display={"flex"}
                        flexDirection={"column"}
                        // justifyContent={"flex-start"}
                      >
                        {loading ? (
                          <HandleSkeletion height={80} />
                        ) : (
                          <Fragment>
                            <CommonGrid2
                              display={"flex"}
                              alignItems={"center"}
                              width={"100%"}
                              gap={"10px"}
                            >
                              <Typography
                                variant="p"
                                color="#344054"
                                fontSize="15px"
                                display="flex"
                                alignItems="center"
                                gap="2px"
                              >
                                {item.title}
                                {item.required && (
                                  <CustomizeSpan color={"red"}>
                                    {" "}
                                    *
                                  </CustomizeSpan>
                                )}
                              </Typography>
                            </CommonGrid2>

                            {item.component === "input" && (
                              <Field name={item.titleName}>
                                {({ field, form }) => {
                                  return (
                                    <CommonTextField
                                      placeholder={item.title}
                                      padding="10px"
                                      error={Boolean(
                                        form.errors[item.titleName]
                                      )}
                                      value={values[item.titleName]}
                                      onChange={(e) => {
                                        setFieldValue(
                                          item.titleName,
                                          e.target.value
                                        );
                                      }}
                                      disabled={item.disabled}
                                      helperText={form.errors[item.titleName]}
                                      // onBlur={handleBlur}
                                    />
                                  );
                                }}
                              </Field>
                            )}
                          </Fragment>
                        )}
                      </CommonGrid2>
                    );
                  })}
                </CommonGrid2>

                <CommonGrid2 container spacing={1} size={12} marginTop={"1rem"}>
                  <Typography variant="body5" width={"100%"}>
                    Security
                  </Typography>
                  {security.map((item, index) => (
                    <CommonGrid2
                      size={12}
                      display={"flex"}
                      gap={"10px"}
                      alignItems={"center"}
                      border={"1px solid #EAECF0"}
                      borderRadius={"10px"}
                      padding={"1rem"}
                    >
                      <CommonGrid2
                        size={12}
                        display={"flex"}
                        gap={"1rem"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                        flexWrap={"wrap"}
                      >
                        <CommonGrid2
                          display={"flex"}
                          gap={"1rem"}
                          alignItems={"center"}
                        >
                          <PasswordIco />
                          <CommonGrid2
                            display={"flex"}
                            flexDirection={"column"}
                          >
                            <Typography variant="body3">{item.name}</Typography>
                            <Typography
                              variant="body3"
                              color="#667085"
                              fontWeight={500}
                            >
                              {item.description}
                            </Typography>
                          </CommonGrid2>
                        </CommonGrid2>

                        {loading ? (
                          <HandleSkeletion
                            height={50}
                            width={120}
                            transform={"scale(1)"}
                          />
                        ) : (
                          <CommonButton
                            value={"Change Password"}
                            fontWeight={700}
                            fontSize={"16px"}
                            padding={"10px 16px"}
                            color="#6941C6"
                            backgroundColor="transparent"
                            boxShadow={"none"}
                            disabled={button.condition}
                            onClick={() => handlePasswordChange(setFieldValue)}
                            customStyle={{
                              "&:hover": {
                                boxShadow: "none",
                              },
                            }}
                          />
                        )}
                      </CommonGrid2>
                    </CommonGrid2>
                  ))}
                </CommonGrid2>

                <CommonGrid2
                  justifyContent={"end"}
                  display={"flex"}
                  gap={"1rem"}
                  marginTop={"1rem"}
                >
                  <CommonButton
                    value={"Onboarding"}
                    fontWeight={600}
                    padding={"8px 1rem"}
                    gap="0px"
                    width="max-content"
                    onClick={() => {
                      const creds =
                        JSON.parse(localStorage.getItem("credential")) || {};
                      creds.is_onboarding_completed = false;
                      localStorage.setItem("credential", JSON.stringify(creds));
                      navigate("/onboarding");
                    }}
                  />
                  {button.condition ? (
                    <CommonButton
                      value={"Edit Details"}
                      startIcon={<EditIcon />}
                      fontWeight={600}
                      padding={"8px 1rem"}
                      gap="0px"
                      width="max-content"
                      onClick={handleEditDetails}
                    />
                  ) : (
                    <Fragment>
                      <CommonButton
                        variant="outlined"
                        value={"Cancel"}
                        fontWeight={600}
                        padding={"8px 1rem"}
                        width="max-content"
                        onClick={handleCancel}
                        disabled={button.disabled}
                        loading={button.cancelLoading}
                      />
                      <CommonButton
                        value={"Save"}
                        fontWeight={600}
                        padding={"8px 1.5rem"}
                        width="max-content"
                        type="submit"
                        disabled={button.disabled}
                        loading={button.saveLoading}
                      />
                    </Fragment>
                  )}
                </CommonGrid2>
              </CommonGrid2>
            </Form>
          );
        }}
      </Formik>

      <DialogCandidateHub
        open={passwordChange.open}
        handleButttonClose={handlePasswordClose}
        icon={<StatusChangeIco margin={"10px 0px 0px 10px"} />}
        footer={<PasswordFooter />}
        title="Password Change"
        titlepadding={"0rem 0px 0px"}
        content={handleContent()}
      />

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </CustomDiv>
  );
}
